import clsx from 'clsx';

export interface MouseClickDragIconProps {
	side: 'left' | 'right';
	className?: string;
}

export function MouseClickDragIcon({ side, className }: MouseClickDragIconProps) {
	const highlightPath =
		side === 'left' ?
			'M12 4.5 C8.74 4.5 6.5 6.74 6.5 9.5 V11 H12 Z'
		:	'M12 4.5 C15.26 4.5 17.5 6.74 17.5 9.5 V11 H12 Z';

	return (
		<svg
			viewBox='-4 -4 32 32'
			fill='none'
			className={clsx('size-[1.75em] text-gray-a12', className)}
			aria-hidden='true'
		>
			{/* mouse body */}
			<path
				d='M12 4.5 C8.74 4.5 6.5 6.74 6.5 9.5 V15 C6.5 17.76 8.74 20 12 20 C15.26 20 17.5 17.76 17.5 15 V9.5 C17.5 6.74 15.26 4.5 12 4.5 Z'
				stroke='currentColor'
				strokeOpacity={0.5}
				strokeWidth={1.4}
				fill='none'
			/>
			{/* button divider + separator */}
			<path d='M12 4.7 V11 M6.5 11 H17.5' stroke='currentColor' strokeOpacity={0.5} strokeWidth={1.2} />
			{/* engaged button */}
			<g transform='translate(-0.5 0.5) translate(12 11) scale(1.2) translate(-12 -11)'>
				<path d={highlightPath} fill='currentColor' fillOpacity={1} />
			</g>
			{/* outward chevrons */}
			<g
				stroke='currentColor'
				strokeOpacity={0.5}
				strokeWidth={1.5}
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='none'
			>
				<path d='M9 -0.5 L12 -3 L15 -0.5' />
				<path d='M9 25 L12 27.5 L15 25' />
				<path d='M1.5 9 L-1 12 L1.5 15' />
				<path d='M22.5 9 L25 12 L22.5 15' />
			</g>
		</svg>
	);
}
